// extracted by mini-css-extract-plugin
export var addressFields = "_n6-0";
export var animationContainer = "_n6-1";
export var footer = "_n6-2";
export var lineItems = "_n6-3";
export var modalContent = "_n6-4";
export var orderName = "_n6-5";
export var strong = "_n6-6";
export var warning = "_n6-7";